window._ = require('lodash');

/**
 * We'll load jQuery plugin which provides support for JavaScript features. This code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}
